import { Link } from 'react-router-dom';
import { Box, HStack, Text } from '@chakra-ui/react';
import { ReactComponent as Deposit } from 'assets/icons/deposit.svg';
import { ReactComponent as Withdraw } from 'assets/icons/withdraw.svg';
import { useAccess } from 'hooks';
import { useTranslation } from 'localization';
import { routes } from 'statics';

const Head: React.FC = () => {
  const { t } = useTranslation('component.exchange');
  const access = useAccess();

  return (
    <Box py={{ base: 4, md: 2 }} px={{ base: 0, md: 0 }}>
      <HStack
        justify={{ base: 'space-between', md: 'space-between' }}
        align="center"
        w="100%"
      >
        <Text
          fontSize="var(--chakra-font-sizes-4xl)"
          fontWeight="500"
          display={{ base: 'none', md: 'inline' }}
        >
          {t('exchange')}
        </Text>
        <HStack>
          {access.withdrawService && (
            <Link to={routes.withdraw.url}>
              <Withdraw cursor="pointer" />
            </Link>
          )}
          <Link to={routes.deposit.url}>
            <Deposit cursor="pointer" />
          </Link>
        </HStack>
      </HStack>
    </Box>
  );
};

export default Head;
